import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Vote } from "lucide-react";

export function PlayerListItem({ player, isCompleted, hasJoined, votes, userId, onVote, onPlayerClick }) {
  return (
    <div
      data-testid={`player-${player.id}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '16px',
        backgroundColor: '#111',
        border: '0.5px solid #333',
        borderRadius: '12px',
        cursor: 'pointer',
        touchAction: 'manipulation',
      }}
      onClick={() => onPlayerClick(player.id)}
    >
      <Avatar style={{ width: '44px', height: '44px', border: '1px solid #444' }}>
        <AvatarFallback style={{ backgroundColor: '#22c55e', color: '#fff', fontWeight: 700 }}>
          {player.name?.charAt(0)}
        </AvatarFallback>
      </Avatar>
      <div style={{ flex: 1 }}>
        <p style={{ fontWeight: 500, color: '#fff', fontSize: '14px' }}>{player.name}</p>
        <p style={{ fontSize: '12px', color: '#6b7280' }}>
          {player.goals || 0} buts · {player.matches_played || 0} matchs
        </p>
      </div>
      <div style={{ textAlign: 'center' }}>
        <span style={{ fontSize: '18px', fontWeight: 700, color: '#22c55e' }}>
          {player.rating?.toFixed(1) || '5.0'}
        </span>
      </div>

      {isCompleted && hasJoined && !votes?.has_voted && player.id !== userId && (
        <button
          data-testid={`vote-mvp-${player.id}`}
          onClick={(e) => { e.stopPropagation(); onVote(player.id); }}
          style={{
            padding: '8px 12px',
            borderRadius: '8px',
            backgroundColor: '#22c55e',
            color: '#fff',
            border: 'none',
            fontSize: '12px',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          <Vote size={14} />
        </button>
      )}

      {isCompleted && votes?.votes_count?.[player.id] > 0 && (
        <Badge style={{ backgroundColor: 'rgba(234,179,8,0.2)', color: '#eab308' }}>
          {votes.votes_count[player.id]} vote{votes.votes_count[player.id] > 1 ? 's' : ''}
        </Badge>
      )}
    </div>
  );
}

export function TeamsDisplay({ teams }) {
  if (!teams) return null;

  return (
    <section data-testid="balanced-teams" style={{ padding: '0 16px 20px 16px' }}>
      <h2 className="font-heading" style={{ fontSize: '14px', fontWeight: 600, color: '#fff', marginBottom: '12px' }}>
        Equipes Equilibrees
      </h2>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div style={{ backgroundColor: '#111', border: '0.5px solid rgba(34,197,94,0.4)', borderRadius: '12px', padding: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
            <span style={{ fontSize: '10px', fontWeight: 700, color: '#22c55e', textTransform: 'uppercase' }}>Equipe A</span>
            <span style={{ fontSize: '10px', color: '#22c55e' }}>{teams.avg_a}</span>
          </div>
          {teams.team_a.map((p) => (
            <div key={p.id} style={{ fontSize: '12px', color: '#fff', marginBottom: '4px' }}>{p.name}</div>
          ))}
        </div>
        <div style={{ backgroundColor: '#111', border: '0.5px solid rgba(59,130,246,0.4)', borderRadius: '12px', padding: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
            <span style={{ fontSize: '10px', fontWeight: 700, color: '#3b82f6', textTransform: 'uppercase' }}>Equipe B</span>
            <span style={{ fontSize: '10px', color: '#3b82f6' }}>{teams.avg_b}</span>
          </div>
          {teams.team_b.map((p) => (
            <div key={p.id} style={{ fontSize: '12px', color: '#fff', marginBottom: '4px' }}>{p.name}</div>
          ))}
        </div>
      </div>
    </section>
  );
}
